"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeDuplicated = void 0;
exports.removeDuplicated = function (array, prop) {
    return array.filter(function (x, i, arr) {
        return arr.map(function (y) { return y[prop]; }).indexOf(x[prop]) === i;
    });
};
